import React from 'react';
import { PageStatus } from '../../constants/PageStatus';
import ErrorPage from '../Error/ErrorPage';
import { RootStateOrAny, useSelector } from 'react-redux';
import RemoveProfile from './RemoveProfile';
import RemoveProfileConfirmation from './RemoveProfileConfirmation';

function RemoveProfilePage() {
  const pageStatus = useSelector(
    (state: RootStateOrAny) => state.pageInfo.pageStatus
  ) as PageStatus;

  if (pageStatus == PageStatus.INITIAL) return <RemoveProfile />;
  else if (pageStatus == PageStatus.SUCCESS)
    return <RemoveProfileConfirmation />;
  else return <ErrorPage />;
}

export default RemoveProfilePage;
